/* eslint-disable jsx-a11y/no-redundant-roles */
import axios from "axios";
import { Alert } from "../../design-system/components";
import "../../design-system/forms.css";
import React, { useEffect, useState } from "react";
import Distancepopup from "../Distancepopup";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { BASE_URL } from "../../config";
import { getOcrErrorMessage, getOcrResponseErrorMessage } from "../../services/ocrErrors";

const normalizeName = (value) => String(value || "")
  .toLowerCase()
  .replace(/\b(incorporated|inc|limited|ltd|corporation|corp|llc)\b/g, "")
  .replace(/[^a-z0-9]+/g, " ")
  .trim();

const getCustomerName = (customer) => customer?.name || customer?.legal || customer?.company_name || customer?.customer_name || customer?.Broker || "";

const companyNameSimilarity = (left, right) => {
  const a = normalizeName(left);
  const b = normalizeName(right);
  if (!a || !b) return 0;
  if (a === b) return 1;
  if (a.includes(b) || b.includes(a)) return 0.88;

  const aTokens = new Set(a.split(/\s+/));
  const bTokens = new Set(b.split(/\s+/));
  const shared = [...aTokens].filter((token) => bTokens.has(token)).length;
  const tokenScore = shared / new Set([...aTokens, ...bTokens]).size;
  const bigrams = (value) => new Set(value.replace(/\s/g, "").split("").slice(1).map((char, index) => value.replace(/\s/g, "")[index] + char));
  const aGrams = bigrams(a);
  const bGrams = bigrams(b);
  const gramShared = [...aGrams].filter((gram) => bGrams.has(gram)).length;
  const gramScore = (2 * gramShared) / Math.max(1, aGrams.size + bGrams.size);
  return Math.max(tokenScore, gramScore);
};

const Createtrips = () => {
  const navigate = useNavigate();
  const [, setOcrRaw] = useState(null);
  const [ocrFile, setOcrFile] = useState(null); // OCR State
  const [isOcrLoading, setIsOcrLoading] = useState(false);
  const [ocrCustomerNotice, setOcrCustomerNotice] = useState("");
  const [ocrBrokerInfo, setOcrBrokerInfo] = useState(null);
  const [pendingCompanyMatch, setPendingCompanyMatch] = useState(null);

  const handleOcrUpload = async () => {
    if (!ocrFile) {
      toast.error("Please select a file to upload");
      return;
    }
    
    setIsOcrLoading(true);
    
    const ocrData = new FormData();
    ocrData.append("file", ocrFile);
    ocrData.append("module_type", "trip");
    const structuredPrompt = `Extract the trip information into a strict JSON format with the following keys exactly:
{
  "loadno": "Load or reference number",
  "company": "Carrier or company name shown in the customer or billing details",
  "customer": "Customer or broker account name, preferably the bill-to party",
  "broker_name": "Broker or bill-to company name shown on the document",
  "broker_contact": "Broker contact person name shown on the document",
  "broker_address": "Broker or bill-to mailing address shown on the document",
  "broker_phone": "Broker phone number shown on the document",
  "broker_email": "Broker email address shown on the document",
  "customerorderno": "Customer purchase order or customer order number",
  "salesman": "Salesperson name, only if explicitly shown",
  "pickup_address": "Full pickup or shipper address",
  "pickup_from": "Pickup company or location name",
  "delivery_address": "Full delivery or consignee address",
  "delivery": "Delivery company or location name",
  "stops": [{ "stoptype": "Pickup or Delivery", "name": "Stop company or location name", "address": "Full stop address", "date": "Stop date in YYYY-MM-DD format", "time": "Stop time if shown" }],
  "pickupdate": "Pickup date in exactly YYYY-MM-DD format",
  "deliverydate": "Delivery date in exactly YYYY-MM-DD format",
  "rate": "Rate or cost as a pure number (no currency symbols)",
  "currency": "Currency explicitly shown for the rate or total; return CAD or USD when identifiable",
  "gross_amount": "Total gross amount as a pure number",
  "trailortype": "Trailer type if mentioned",
  "commodity": "Commodity description",
  "weight": "Weight as a pure number",
  "unit": "Weight unit (LBS/KGS)"
}
Return ONLY valid JSON and do not include markdown formatting or extra text.`;
    ocrData.append("prompt", structuredPrompt);

    try {
      const response = await axios.post(
        `${BASE_URL}OCRController/simple_openai_process`,
        ocrData,
        { withCredentials: true }
      );

      if (response.data.success) {
        setOcrRaw(response.data.data);
        applyOCRToAllFields(response.data);
      } else {
        toast.error(getOcrResponseErrorMessage(response));
      }
    } catch (err) {
      console.error("Trip OCR request failed:", err.response?.status || err.message);
      toast.error(getOcrErrorMessage(err, "Error processing OCR file"));
    } finally {
      setIsOcrLoading(false);
    }
  };

  const [shipments, setShipments] = useState([
    {
      commodity: [""],
      weight: [""],
      unit: [""],
      package: [""],
      trailortype: "",
      manifest: "",
      hazmat: "",
      addlcharge: "",
      appt: "",
      pip: "",
      ctpat: "",
    },
  ]);

  const [showShipmentsPopup, setShowShipmentsPopup] = useState(false);
  const [activeShipmentIndex, setActiveShipmentIndex] = useState(0);
  const [data, setdata] = useState([]);
  const [paperworkList, setPaperworkList] = useState([]);
  const [, seterror] = useState([]);
  let userdata = JSON.parse(localStorage.getItem("logindetail"));
  const [stops, setStops] = useState([]);
  const [draggedIndex, setDraggedIndex] = useState(null);

  // Add new shipment
  const addNewShipment = () => {
    setShipments((prev) => [
      ...prev,
      {
        commodity: [""],
        weight: [""],
        unit: [""],
        package: [""],
        trailortype: "",
        manifest: "",
        hazmat: "",
        addlcharge: "",
        appt: "",
        pip: "",
        ctpat: "",
      },
    ]);
  };

  // Remove shipment
  const removeShipment = (index) => {
    if (shipments.length > 1) {
      setShipments((prev) => prev.filter((_, i) => i !== index));
      if (activeShipmentIndex >= index) {
        setActiveShipmentIndex((prev) => Math.max(0, prev - 1));
      }
    }
  };

  // Update shipment data

  // Handle array fields in shipments (commodity, weight, etc.)
  const handleShipmentArrayChange = (index, field, arrayIndex, value) => {
    setShipments((prev) => {
      const updated = [...prev];
      if (!updated[index][field]) {
        updated[index][field] = [];
      }
      updated[index][field][arrayIndex] = value;
      return updated;
    });
  };

  // Add row to specific shipment
  const handleAddRowToShipment = (shipmentIndex) => {
    setShipments((prev) => {
      const updated = [...prev];
      const currentRows = updated[shipmentIndex].commodity.length;

      updated[shipmentIndex].commodity[currentRows] = "";
      updated[shipmentIndex].weight[currentRows] = "";
      updated[shipmentIndex].unit[currentRows] = "";
      updated[shipmentIndex].package[currentRows] = "";

      return updated;
    });
  };

  // Remove row from specific shipment
  const handleRemoveRowFromShipment = (shipmentIndex, rowIndex) => {
    setShipments((prev) => {
      const updated = [...prev];
      updated[shipmentIndex].commodity = updated[
        shipmentIndex
      ].commodity.filter((_, i) => i !== rowIndex);
      updated[shipmentIndex].weight = updated[shipmentIndex].weight.filter(
        (_, i) => i !== rowIndex
      );
      updated[shipmentIndex].unit = updated[shipmentIndex].unit.filter(
        (_, i) => i !== rowIndex
      );
      updated[shipmentIndex].package = updated[shipmentIndex].package.filter(
        (_, i) => i !== rowIndex
      );
      return updated;
    });
  };
  // Drag and Drop handlers
  const handleDragStart = (e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", index);
    e.currentTarget.style.opacity = "0.5";
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };

  const handleDrop = (e, index) => {
    e.preventDefault();
    if (draggedIndex !== null && draggedIndex !== index) {
      const updatedStops = [...stops];
      const [movedItem] = updatedStops.splice(draggedIndex, 1);
      updatedStops.splice(index, 0, movedItem);
      setStops(updatedStops);
    }
    setDraggedIndex(null);
  };

  const handleDragEnd = (e) => {
    e.currentTarget.style.opacity = "1";
    setDraggedIndex(null);
  };
  const addStop = () => {
    const newStop = {
      stoptype: "Delivery", // Default value
      name: "",
      location: "",
      date: "",
      time: "",
    };
    setStops([...stops, newStop]);
  };

  const handleStopChange = (index, field, value) => {
    const updatedStops = [...stops];
    updatedStops[index][field] = value;
    setStops(updatedStops);
  };
  const [formData, setFormData] = useState({
    mode: "LOG",

    company: "",
    customerorderno: "",
    shipmenttype: "",
    commission: "",
    customer_id: "",

    loadtype: "",
    frieghton: "",
    salesman: "",
    scaleticketno: "",

    pickup_from: "",
    pickup_address: "",
    pickupdate: "",
    pickuptime: "",
    pickup_refno: "",
    pickup_desc: "",

    delivery: "",
    delivery_address: "",
    deliverydate: "",
    deliverytime: "",
    delivery_refno: "",
    dappointment: "NO", // ✅ ADD default
    delivery_desc: "",

    lat: "",
    lng: "",
    source_lat: "",
    source_lng: "",

    commodity: [""],
    weight: [""],
    unit: [""], // ✅ REQUIRED
    package: [""],

    trailortype: "",
    manifest: "NO",
    hazmat: "NO",
    addlcharge: "0",
    appt: "NO",
    pip: "NO",
    ctpat: "NO",
    custom_paper: "",

    loadno: "",

    rate: "",
    ratevalue: "",
    currency: "CAD",
    gross_amount: "",
    hst: "",
    hstamount: "",
    cst: "",
    cstamount: "",
    net_amount: "",
  });

  const [, setmessage] = useState();
  const [popup, setpopup] = useState(false);
  const [saveError, setSaveError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [popup1, setpopup1] = useState(false);

  const normalizeShipments = () => {
    return shipments.map((s) => ({
      commodity: s.commodity,
      weight: s.weight,
      unit: s.unit,
      package: s.package,

      trailortype: s.trailortype || formData.trailortype || "",
      manifest: s.manifest || "NO",
      hazmat: s.hazmat || "NO",
      addlcharge: s.addlcharge || "0",
      appt: s.appt || "NO",
      pip: s.pip || "NO",
      ctpat: s.ctpat || "NO",
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "delivery") {
      // Find the selected location based on the value (id)
      const selectedLocation = data.locations.find((item) => item.id === value);

      // Update formData with the new delivery address and delivery id
      setFormData({
        ...formData,
        [name]: value,
        delivery_address: selectedLocation ? selectedLocation.address1 : "",
      });
    } else if (name === "pickup_from") {
      const selectedLocation = data.locations.find((item) => item.id === value);

      // Update formData with the new delivery address and delivery id
      setFormData({
        ...formData,
        [name]: value,
        pickup_address: selectedLocation ? selectedLocation.address1 : "",
      });
    } else {
      // For other input fields
      setFormData({
        ...formData,
        [name]: value,
      });
    }
    // Perform calculations if relevant fields change
    if (["gross_amount", "hst", "cst", "rate", "ratevalue"].includes(name)) {
      calculateAmounts(name, value);
    }
  };


  const flattenObject = (obj, prefix = "", res = {}) => {
    for (let key in obj) {
      const value = obj[key];
      const newKey = prefix ? `${prefix}_${key}` : key;

      if (typeof value === "object" && value !== null) {
        flattenObject(value, newKey, res);
      } else {
        res[newKey.toLowerCase()] = String(value);
      }
    }
    return res;
  };

  const applyOCRToAllFields = (ocrResponse) => {
    if (!ocrResponse) return;

    const gptData = ocrResponse.gpt_response?.structured_json || {};
    const ocrDataRaw = ocrResponse.data || {};
    const flatOCR = flattenObject(ocrDataRaw);

    // --- UNIVERSAL MAPPING SOURCE GENERATION ---
    const combinedSource = { ...flatOCR };

    if (gptData.names) gptData.names.forEach((n, i) => combinedSource[`gpt_name_${i}`] = n);
    if (gptData.addresses) gptData.addresses.forEach((a, i) => combinedSource[`gpt_address_${i}`] = a);
    if (gptData.dates) Object.entries(gptData.dates).forEach(([k, v]) => combinedSource[`gpt_date_${k}`] = v);
    if (gptData.numbers) Object.entries(gptData.numbers).forEach(([k, v]) => combinedSource[`gpt_number_${k}`] = v);
    if (gptData.records?.[0]) {
      Object.entries(gptData.records[0]).forEach(([k, v]) => combinedSource[`rec_${k}`] = String(v));
    }

    const flatGPT = flattenObject(gptData);
    Object.entries(flatGPT).forEach(([k, v]) => {
      combinedSource[`gpt_${k}`] = String(v);
    });

    const sourceKeys = Object.keys(combinedSource);
    const normalizeKey = (key) => key.toLowerCase().replace(/^(gpt|rec)_/, "").replace(/[^a-z0-9]+/g, "_");
    const getMatch = (synonyms) => {
      const terms = synonyms.map(normalizeKey);
      const exactKey = sourceKeys.find((key) => terms.includes(normalizeKey(key)));
      if (exactKey) return combinedSource[exactKey];
      const suffixKey = sourceKeys.find((key) => terms.some((term) => normalizeKey(key).endsWith(`_${term}`)));
      if (suffixKey) return combinedSource[suffixKey];
      const partialKey = sourceKeys.find((key) => terms.some((term) => normalizeKey(key).includes(term)));
      return partialKey ? combinedSource[partialKey] : null;
    };

    const companyVal = getMatch(["company_name", "company", "carrier_name", "billing_company"]);
    const brokerVal = getMatch(["broker_name", "broker", "customer_name", "customer", "bill_to"]);
    const brokerOcrFields = {
      name: brokerVal,
      contact: getMatch(["broker_contact", "broker_contact_name", "customer_contact", "bill_to_contact"]),
      address: getMatch(["broker_address", "customer_address", "bill_to_address"]),
      phone: getMatch(["broker_phone", "customer_phone", "bill_to_phone"]),
      email: getMatch(["broker_email", "customer_email", "bill_to_email"]),
    };
    const visibleBrokerOcrFields = Object.fromEntries(
      Object.entries(brokerOcrFields)
        .filter(([, value]) => value !== null && value !== undefined && String(value).trim() !== "")
        .map(([key, value]) => [key, String(value).trim()])
    );
    setOcrBrokerInfo(Object.keys(visibleBrokerOcrFields).length ? visibleBrokerOcrFields : null);
    const customerOrderVal = getMatch(["customerorderno", "customer_order_no", "purchase_order_number", "po_number", "customer_po", "reference_number"]);
    const salesmanVal = getMatch(["salesman", "salesperson"]);
    const extractedStops = Array.isArray(gptData.stops)
      ? gptData.stops
      : Array.isArray(ocrDataRaw.stops) ? ocrDataRaw.stops : [];
    const findKnownName = (options, value, labelKey) => {
      const requested = normalizeName(value);
      if (!requested) return null;
      const label = (option) => labelKey === "customer" ? getCustomerName(option) : option[labelKey];
      const exact = options.find((option) => normalizeName(label(option)) === requested);
      if (exact) return exact;
      const ranked = options
        .map((option) => ({ option, score: companyNameSimilarity(requested, label(option)) }))
        .filter((candidate) => candidate.score >= 0.62)
        .sort((left, right) => right.score - left.score);
      if (!ranked.length) return null;
      if (ranked.length > 1 && ranked[0].score - ranked[1].score < 0.06) return null;
      return ranked[0].option;
    };
    const companyCandidates = (data.company_data || [])
      .map((company) => ({
        company,
        score: companyNameSimilarity(companyVal, company.company_name),
      }))
      .filter((candidate) => candidate.score >= 0.42)
      .sort((left, right) => right.score - left.score)
      .slice(0, 5);
    const matchedBroker = findKnownName(data.customers || [], brokerVal, "customer");
    const matchedSalesman = findKnownName(data.customers || [], salesmanVal, "customer");
    const customerNotes = [];
    if (companyVal && companyCandidates.length === 0) customerNotes.push(`Company “${companyVal}” was read but no similar company was found. Select the correct company manually.`);
    if (brokerVal && !matchedBroker) customerNotes.push(`Customer/broker “${brokerVal}” was read but could not be matched to a broker account.`);
    if (salesmanVal && !matchedSalesman) customerNotes.push(`Salesperson “${salesmanVal}” was read but could not be matched to a user record.`);
    setOcrCustomerNotice(customerNotes.join(" "));
    if (companyVal && companyCandidates.length > 0) {
      setPendingCompanyMatch({
        ocrName: String(companyVal).trim(),
        candidates: companyCandidates,
        selectedId: String(companyCandidates[0].company.id),
      });
    } else {
      setPendingCompanyMatch(null);
    }

    let localMatchCount = 0;
    const asStopText = (value) => typeof value === "string" || typeof value === "number" ? String(value).trim() : "";
    const ocrStops = extractedStops.map((stop) => {
      if (typeof stop === "string") {
        return { stoptype: "Delivery", name: "", location: stop.trim(), date: "", time: "" };
      }
      if (!stop || typeof stop !== "object") return null;
      const name = asStopText(stop.name || stop.location_name || stop.company || stop.label);
      const address = asStopText(stop.address || stop.full_address || stop.location || stop.address1);
      const rawType = asStopText(stop.stoptype || stop.stop_type || stop.type).toLowerCase();
      return {
        stoptype: /pickup|origin|shipper|load/.test(rawType) ? "Pickup" : "Delivery",
        name,
        location: address || name,
        date: asStopText(stop.date || stop.stop_date || stop.arrival_date),
        time: asStopText(stop.time || stop.stop_time || stop.arrival_time),
      };
    }).filter((stop) => stop && stop.location);

    let mappedStops = ocrStops;
    if (mappedStops.length === 0) {
      const pickupStopAddress = getMatch(["pickup_address", "shipper_address", "origin_address"]);
      const pickupStopName = getMatch(["pickup_from", "shipper", "origin", "pickup_location"]);
      const deliveryStopAddress = getMatch(["delivery_address", "consignee_address", "destination_address"]);
      const deliveryStopName = getMatch(["delivery", "consignee", "destination", "delivery_location"]);
      mappedStops = [
        (pickupStopAddress || pickupStopName) && {
          stoptype: "Pickup", name: asStopText(pickupStopName),
          location: asStopText(pickupStopAddress || pickupStopName), date: "", time: "",
        },
        (deliveryStopAddress || deliveryStopName) && {
          stoptype: "Delivery", name: asStopText(deliveryStopName),
          location: asStopText(deliveryStopAddress || deliveryStopName), date: "", time: "",
        },
      ].filter(Boolean);
    }
    if (mappedStops.length > 0) {
      setStops(mappedStops);
      localMatchCount += mappedStops.length;
    }

    setFormData((prev) => {
      const updated = { ...prev };

      const isFieldEmpty = (val) => {
        if (val === null || val === undefined) return true;
        const s = String(val).trim();
        if (s === "") return true;
        if (Array.isArray(val)) return val.length === 0 || (val.length === 1 && String(val[0]).trim() === "");
        return false;
      };

      // 1. Map Load Number & Salesman (Allow overwrite for loadno)
      if (customerOrderVal) {
        updated.customerorderno = String(customerOrderVal).trim();
        localMatchCount++;
      }
      if (matchedBroker) {
        updated.customer_id = String(matchedBroker.id);
        localMatchCount++;
      }
      if (matchedSalesman) {
        updated.salesman = String(matchedSalesman.id);
        localMatchCount++;
      }

      const loadVal = getMatch(['rec_load_number', 'gpt_number_load', 'loadno', 'load_number', 'load']);
      if (loadVal) {
        updated.loadno = String(loadVal);
        localMatchCount++;
      }

      // Explicitly map Trailer Type for the Dropdown (requires ID)
      const trailerVal = getMatch(['trailortype', 'trailer']);
      if (trailerVal && isFieldEmpty(updated.trailortype)) {
        const trailer = data.trailors?.find(t => t.trailortype?.toLowerCase().includes(String(trailerVal).toLowerCase()));
        if (trailer) {
          updated.trailortype = trailer.id;
        } else {
          updated.trailortype = String(trailerVal);
        }
        localMatchCount++;
      }

      // 2. Map Addresses & Locations
      const pickupAddr = getMatch(['rec_pickup_address', 'gpt_address_0', 'addresses', 'pickup_addr', 'shipper_address', 'origin_address', 'address', 'pickup_address']);
      if (pickupAddr && isFieldEmpty(updated.pickup_address)) {
        updated.pickup_address = String(pickupAddr);
        localMatchCount++;
      }

      const pickupLoc = getMatch(['shipper', 'ship_from', 'pickup_loc', 'origin', 'pickup_from']);
      if (pickupLoc && isFieldEmpty(updated.pickup_from)) {
        const loc = data.locations?.find(l => l.name?.toLowerCase().includes(String(pickupLoc).toLowerCase()));
        if (loc) { updated.pickup_from = loc.id; localMatchCount++; }
      }

      const deliveryAddr = getMatch(['rec_delivery_address', 'gpt_address_1', 'addresses', 'delivery_addr', 'consignee_address', 'destination_address', 'delivery_address']);
      if (deliveryAddr && isFieldEmpty(updated.delivery_address)) {
        updated.delivery_address = String(deliveryAddr);
        localMatchCount++;
      }

      const deliveryLoc = getMatch(['consignee', 'ship_to', 'delivery_loc', 'destination', 'delivery']);
      if (deliveryLoc && isFieldEmpty(updated.delivery)) {
        const loc = data.locations?.find(l => l.name?.toLowerCase().includes(String(deliveryLoc).toLowerCase()));
        if (loc) { updated.delivery = loc.id; localMatchCount++; }
      }

      // 3. Map Dates
      const pickupDate = getMatch(['rec_pickup_date', 'gpt_date_pickup', 'pickup_date', 'pickupdate']);
      if (pickupDate && isFieldEmpty(updated.pickupdate)) {
        updated.pickupdate = String(pickupDate);
        localMatchCount++;
      }

      const deliveryDate = getMatch(['rec_delivery_date', 'gpt_date_delivery', 'delivery_date', 'deliverydate']);
      if (deliveryDate && isFieldEmpty(updated.deliverydate)) {
        updated.deliverydate = String(deliveryDate);
        localMatchCount++;
      }

      // Explicitly map Rate and Gross Amount (since they are not in the default formData keys)
      const rateVal = getMatch(['rate', 'cost']);
      if (rateVal && isFieldEmpty(updated.rate)) {
        updated.rate = String(rateVal).replace(/[^\d.]/g, "");
        localMatchCount++;
      }

      const grossVal = getMatch(['gross_amount', 'total_amount', 'grossamount']);
      if (grossVal && isFieldEmpty(updated.gross_amount)) {
        updated.gross_amount = String(grossVal).replace(/[^\d.]/g, "");
        localMatchCount++;
      }

      const currencyVal = getMatch(["currency", "currency_code", "charge_currency"]);
      if (currencyVal) {
        const normalizedCurrency = String(currencyVal).toUpperCase();
        if (/\bUSD\b|US\s*\$|U\.S\.\s*DOLLAR/.test(normalizedCurrency)) updated.currency = "USD";
        else if (/\bCAD\b|CA\s*\$|CANADIAN\s*DOLLAR/.test(normalizedCurrency)) updated.currency = "CAD";
        else if (normalizedCurrency.trim() === "USD" || normalizedCurrency.trim() === "CAD") updated.currency = normalizedCurrency.trim();
      }

      // Explicitly map Commodity, Weight, and Unit (Handle specific unit mappings like LBS -> Pounds)
      const commodityVal = getMatch(['commodity', 'product', 'freight_specifics']);
      if (commodityVal && isFieldEmpty(updated.commodity)) {
        updated.commodity = [String(commodityVal)];
        localMatchCount++;
      }

      const weightVal = getMatch(['weight']);
      if (weightVal && isFieldEmpty(updated.weight)) {
        updated.weight = [String(weightVal).replace(/[^\d.]/g, "")];
        localMatchCount++;
      }

      const unitVal = getMatch(['unit', 'weight_unit']);
      if (unitVal && isFieldEmpty(updated.unit)) {
        let uStr = String(unitVal).toUpperCase();
        if (uStr.includes("LBS") || uStr.includes("POUND")) uStr = "Pounds";
        else if (uStr.includes("KGS") || uStr.includes("KILOS")) uStr = "KGs";
        else if (uStr.includes("TON")) uStr = "Tons";
        updated.unit = [uStr];
        localMatchCount++;
      }

      // 4. Final catch-all & Logic for Arrays/Numbers
      Object.keys(updated).forEach(field => {
        const isDefault = ["No", "Regular", "LTL", "Hazmat", "13", "0"].includes(String(updated[field]));
        if (!isFieldEmpty(updated[field]) && !isDefault && field !== 'loadno') return;

        const val = getMatch([field]);
        if (val) {
          if (Array.isArray(updated[field])) {
            updated[field] = [String(val)];
          } else if (!isNaN(prev[field]) && typeof prev[field] === 'number') {
            updated[field] = String(val).replace(/[^\d.]/g, "");
          } else {
            updated[field] = String(val).substring(0, 300);
          }
          localMatchCount++;
        }
      });

      return updated;
    });

    // Update shipments state separately so the UI correctly reflects commodities
    const commodityVal = getMatch(['commodity']);
    const weightVal = getMatch(['weight']);
    const unitVal = getMatch(['unit']);
    const trailerVal = getMatch(['trailortype', 'trailer']);
    
    if (commodityVal || weightVal || unitVal || trailerVal) {
      setShipments(prevShipments => {
        const updatedShipments = [...prevShipments];
        if (commodityVal) {
            updatedShipments[0].commodity = [String(commodityVal)];
            localMatchCount++;
        }
        if (weightVal) {
            updatedShipments[0].weight = [String(weightVal)];
            localMatchCount++;
        }
        if (unitVal) {
            updatedShipments[0].unit = [String(unitVal)];
            localMatchCount++;
        }
        if (trailerVal) {
            updatedShipments[0].trailortype = String(trailerVal);
            localMatchCount++;
        }
        return updatedShipments;
      });
    }

    setTimeout(() => {
        if (localMatchCount > 0) {
          toast.success(`OCR processed successfully. Mapped ${localMatchCount} details.`);
        } else {
          toast.warning("OCR processed but no matching fields found.");
        }
    }, 500);
  };

  const confirmOcrCompany = () => {
    if (!pendingCompanyMatch) return;
    const selected = pendingCompanyMatch.candidates.find(
      (candidate) => String(candidate.company.id) === pendingCompanyMatch.selectedId
    );
    if (!selected) return;
    setFormData((prev) => ({ ...prev, company: selected.company.company_name }));
    setPendingCompanyMatch(null);
    setOcrCustomerNotice((prev) => prev.replace(/Company “[^”]+” was read but no similar company was found\. Select the correct company manually\.?\s*/g, ""));
    toast.success(`Company confirmed: ${selected.company.company_name}`);
  };


  const calculateAmounts = (name, value) => {
    const rate = parseFloat(name === "rate" ? value : formData.rate) || 0;
    const rateValue =
      parseFloat(name === "ratevalue" ? value : formData.ratevalue) || 0;

    // Calculate gross amount dynamically
    const gross =
      name === "rate" || name === "ratevalue"
        ? rate * rateValue
        : parseFloat(formData.gross_amount) || 0;

    const hst = parseFloat(name === "hst" ? value : formData.hst) || 0;
    const cst = parseFloat(name === "cst" ? value : formData.cst) || 0;

    // Calculate HST and CST amounts
    const hstAmount = (gross * hst) / 100;
    const cstAmount = (gross * cst) / 100;

    // Calculate Net Amount
    const netAmount = gross + hstAmount + cstAmount;

    // Update formData with calculated values
    setFormData((prev) => ({
      ...prev,
      gross_amount: gross.toFixed(2),
      hstamount: hstAmount.toFixed(2),
      cstamount: cstAmount.toFixed(2),
      net_amount: netAmount.toFixed(2),
    }));
  };
  const handleInputChange2 = (e, index, field) => {
    const { value } = e.target;

    setFormData((prevState) => {
      const updatedFormData = { ...prevState };

      // Ensure the array exists in the state
      if (!updatedFormData[field]) {
        updatedFormData[field] = [];
      }

      // Update the value at the specified index
      updatedFormData[field][index] = value;

      return updatedFormData;
    });
  };



  // eslint-disable-next-line react-hooks/exhaustive-deps
  const [, setRows] = useState([]); // Correctly placed
  const handleAddRow = () => {
    // This function originally added JSX rows to state, which is an anti-pattern.
    // However, given the existing codebase, I will fix the ReferenceError first.
    // Ideally, this should rely on formData length, similar to Createorder.js.
    // For now, to stop the crash:
    setRows((prevRows) => [
      ...prevRows,
      // Placeholder to maintain count, actual rendering should be map-based
      prevRows.length + 1
    ]);
  };

  useEffect(() => {
    axios
      .get(`${BASE_URL}api/getOrderData`)
      .then((res) => {
        setdata(res.data);
        setFormData(prev => ({
          ...prev,
          customerorderno: res && res.data.triprno,
          loadno: (res && res.data.loadno) || prev.loadno,
        }));
        console.log(res.data);
      })
      .catch((error) => seterror(error));

    // Call handleAddRow if needed for initialization
    // handleAddRow(); 
    // Commented out because simply initializing state is safer than calling a state updater in effect without deps
    fetchPaperworks();
  }, []);

  const fetchPaperworks = async () => {
    try {
      const res = await axios.get(`${BASE_URL}api/listCustompapers`);
      const data = res.data;
      if (data.status === "success") setPaperworkList(data.data || []);
    } catch (err) {
      console.error(err);
    }
  };



  const handleonSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setSaveError("");
    setIsSubmitting(true);

    const form = new FormData();

    // 🔹 All normal fields
    Object.keys(formData).forEach((key) => {
      if (Array.isArray(formData[key])) {
        formData[key].forEach((item) => {
          form.append(`${key}[]`, item);
        });
      } else {
        form.append(key, formData[key]);
      }
    });

    // 🔹 REQUIRED BY BACKEND
    form.append("userid", userdata.id);
    form.append("mode", "LOG");

    // 🔹 Stops
    form.append("Location12", JSON.stringify(stops));

    // 🔹 Shipments (FIXED)
    form.append("shipments", JSON.stringify(normalizeShipments()));

    try {
      const response = await axios.post(
        `${BASE_URL}api/create`,
        form
      );
      setmessage(response.data.message);
      toast.success("Successfully created", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });

      navigate(-1);
    } catch (error) {
      setSaveError("The trip could not be saved. Your entries are preserved. Check your connection before retrying.");
      toast.error("Trip creation failed");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSaveAndAssign = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setSaveError("");
    setIsSubmitting(true);

    const form = new FormData();
    // Append regular fields
    Object.keys(formData).forEach((key) => {
      if (Array.isArray(formData[key])) {
        formData[key].forEach((item) => form.append(`${key}[]`, item)); // Append arrays
      } else {
        form.append(key, formData[key]);
      }
    });
    form.append("shipments", JSON.stringify(normalizeShipments()));

    form.append("userid", userdata.id);
    form.append("Location12", JSON.stringify(stops));
    form.append("mode", "LOG");

    try {
      const response = await axios.post(
        `${BASE_URL}api/create`,
        form
      );
      setmessage(response.data.message);
      toast.success("Successfully created", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      navigate(`/trips/assign/${response.data.id}`);
    } catch (error) {
      setSaveError("The trip could not be saved or assigned. Your entries are preserved. Check your connection before retrying.");
      toast.error("Trip creation failed", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps


  const handleRemoveRow = (index) => {
    setRows((prevRows) => prevRows.filter((row, i) => i !== index - 1));
  };

  const selectedCompanyRecord = (data.company_data || []).find(
    (company) => company.company_name === formData.company
  );
  const selectedBrokerRecord = (data.customers || []).find(
    (customer) => String(customer.id) === String(formData.customer_id)
  );
  const companyDetails = (company) => Object.entries(company || {}).filter(
    ([key, value]) => !["id", "company_name"].includes(key.toLowerCase()) &&
      value !== null && value !== undefined && String(value).trim() !== "" &&
      ["string", "number", "boolean"].includes(typeof value)
  );
  const brokerDetails = (broker) => [
    ["Legal name", broker?.legal],
    ["Address", broker?.address1],
    ["Address line 2", broker?.address2],
    ["Phone", broker?.phone],
    ["Toll free", broker?.tollfree],
    ["Extension", broker?.ext],
    ["Email", broker?.email],
    ["Website", broker?.website],
    ["Pickup email", broker?.pickupmail],
    ["Delivery email", broker?.deliverymail],
  ].filter(([, value]) => value !== null && value !== undefined && String(value).trim() !== "");

  return (
    <div className="content-wrapper trip-create-page iso-ui iso-form-workspace" data-iso-theme="light">
      <section className="content-header">
        <div className="form-group">
          <label htmlFor="product_image">Upload Document (OCR Auto-fill)</label>
          <div className="input-group">
            <input
              type="file"
              id="product_image"
              aria-describedby="trip-ocr-help"
              name="product_image"
              accept=".png,.jpg,.jpeg,.pdf"
              className="form-control"
              onChange={(e) => setOcrFile(e.target.files[0])}
            />
            <span className="input-group-btn">
              <button
                type="button"
                className="btn btn-success"
                onClick={handleOcrUpload}
                disabled={isOcrLoading}
              >
                {isOcrLoading ? (
                  <>
                    <i className="fa fa-spinner fa-spin" style={{ marginRight: "5px" }}></i>
                    Processing...
                  </>
                ) : (
                  "Scan & Auto-fill"
                )}
              </button>
            </span>
          </div>
          <p className="help-block" id="trip-ocr-help">Upload a PDF or image, then review customer matches, stop sequence and pricing before saving.</p>
        </div>

        <h1>Create trip <small>Enter shipment and route details</small></h1>
        <ol className="breadcrumb">
          <li>
            <Link to="#">
              <i className="fa fa-dashboard" /> Home
            </Link>
          </li>
          <li className="active">Trips</li>
        </ol>
      </section>
      <section className="content">
        <nav className="trip-form-navigation" aria-label="Trip form sections">
          <span className="trip-form-navigation-label">Jump to</span>
          <a href="#trip-customer-details">Customer</a>
          <a href="#trip-route-details">Pickup &amp; delivery</a>
          <a href="#trip-shipment-details">Cargo</a>
          <a href="#trip-revenue-details">Pricing</a>
          <button type="button" className="btn btn-primary btn-sm" onClick={() => setpopup(true)}>Review &amp; save</button>
        </nav>
        {/* Small boxes (Stat box) */}
        <div className="row">
          <div className="col-md-12 col-xs-12">
            <div id="messages" />
            <div className="box">
              <div className="col-md-12 col-xs-12 pull pull-left">
                <div className="form-group">
                  <h4 id="trip-customer-details">
                    <span className="label label-success">
                      CUSTOMER DETAILS
                    </span>
                  </h4>
                  <h3 align="center">TRIP # : {data && data.triprno}</h3>
                  {ocrCustomerNotice && <div className="alert alert-info" role="status">{ocrCustomerNotice}</div>}
                </div>
              </div>
              {/* /.box-header */}
              <form
                role="form"
                action=""
                method="post"
                encType="multipart/form-data"
              >
                <div className="box-body">
                  <div className="col-md-6 col-xs-12 pull pull-left">
                    <div className="col-md-12 col-xs-12 pull pull-left">
                      <div className="form-group">
                        <label htmlFor="company">Company</label>
                        <select
                          className="form-control"
                          id="company"
                          name="company"
                          value={formData.company}
                          onChange={handleInputChange}
                        >
                          <option value="">Select Company</option>
                          {formData.company && !data.company_data?.some((item) => item.company_name === formData.company) && (
                            <option value={formData.company}>{formData.company} (from OCR; review)</option>
                          )}
                          {data.company_data?.map((item) => (
                            <option key={item.id || item.company_name} value={item.company_name}>
                              {item.company_name}
                            </option>
                          ))}
                        </select>
                        {pendingCompanyMatch && (
                          <div className="alert alert-warning" role="status" style={{ marginTop: 10 }}>
                            <strong>Confirm company from OCR</strong>
                            <p style={{ margin: "6px 0" }}>
                              OCR read <strong>{pendingCompanyMatch.ocrName}</strong>. Choose the matching company and review its saved details before confirming.
                            </p>
                            <select
                              className="form-control"
                              aria-label="Suggested company matches"
                              value={pendingCompanyMatch.selectedId}
                              onChange={(event) => setPendingCompanyMatch((prev) => ({ ...prev, selectedId: event.target.value }))}
                            >
                              {pendingCompanyMatch.candidates.map(({ company, score }) => (
                                <option key={company.id} value={String(company.id)}>
                                  {company.company_name} ({Math.round(score * 100)}% similar)
                                </option>
                              ))}
                            </select>
                            {companyDetails(pendingCompanyMatch.candidates.find(
                              ({ company }) => String(company.id) === pendingCompanyMatch.selectedId
                            )?.company).length > 0 && (
                              <dl className="row" style={{ margin: "10px 0" }}>
                                {companyDetails(pendingCompanyMatch.candidates.find(
                                  ({ company }) => String(company.id) === pendingCompanyMatch.selectedId
                                )?.company).map(([key, value]) => (
                                  <React.Fragment key={key}>
                                    <dt className="col-sm-4">{key.replace(/_/g, " ")}</dt>
                                    <dd className="col-sm-8">{String(value)}</dd>
                                  </React.Fragment>
                                ))}
                              </dl>
                            )}
                            <button type="button" className="btn btn-primary btn-sm" onClick={confirmOcrCompany}>
                              Confirm this company
                            </button>{" "}
                            <button type="button" className="btn btn-default btn-sm" onClick={() => setPendingCompanyMatch(null)}>
                              Dismiss suggestion
                            </button>
                          </div>
                        )}
                        {!pendingCompanyMatch && selectedCompanyRecord && companyDetails(selectedCompanyRecord).length > 0 && (
                          <div className="well well-sm" aria-label="Selected company details" style={{ marginTop: 10, marginBottom: 0 }}>
                            <strong>Company details</strong>
                            <dl className="row" style={{ margin: "8px 0 0" }}>
                              {companyDetails(selectedCompanyRecord).map(([key, value]) => (
                                <React.Fragment key={key}>
                                  <dt className="col-sm-4">{key.replace(/_/g, " ")}</dt>
                                  <dd className="col-sm-8">{String(value)}</dd>
                                </React.Fragment>
                              ))}
                            </dl>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12 col-xs-12">
                      <div className="form-group">
                        <label htmlFor="customerorderno">Customer Order / PO #</label>
                        <input
                          type="text"
                          className="form-control"
                          id="customerorderno"
                          name="customerorderno"
                          placeholder="Enter the customer's PO or order number"
                          autoComplete="off"
                          value={formData.customerorderno || ""}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-xs-12 pull pull-left">
                      <div className="form-group">
                        <label htmlFor="shipmenttype">Shipment Type</label>
                        <select
                          className="form-control"
                          id="shipmenttype"
                          name="shipmenttype"
                          value={formData.shipmenttype}
                          onChange={handleInputChange}
                        >
                          <option value="Regular">Regular</option>
                          <option value="into Canada">into Canada</option>
                          <option value="into USA">into USA</option>
                          <option value="round">round</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6 col-xs-12 pull pull-left">
                      <div className="form-group">
                        <label htmlFor="commission">Commmission</label>
                        <select
                          className="form-control"
                          id="commission"
                          name="commission"
                          value={formData.commission}
                          onChange={handleInputChange}
                        >
                          <option value="Order">Order</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12 col-xs-12 pull pull-left">
                      <div className="form-group">
                        <label htmlFor="custom_paper">Custom Paper</label>
                        <select
                          className="form-control"
                          id="custom_paper"
                          name="custom_paper"
                          value={formData.custom_paper}
                          onChange={handleInputChange}
                        >
                          <option value="">-- Select Custom Paper --</option>
                          {paperworkList.map((paper) => (
                            <option key={paper.id} value={paper.id}>
                              {paper.custom_paper?.split("/").pop() || "Paper " + paper.id}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-12 pull pull-right">
                    <div className="col-md-12 col-xs-12 pull pull-left">
                      <div className="form-group">
                        <label htmlFor="customer_id">Brokers</label>
                        <select
                          className="form-control"
                          id="customer_id"
                          name="customer_id"
                          value={formData.customer_id}
                          onChange={handleInputChange}
                        >
                          <option value="">Select customer/broker</option>
                          {data.customers?.map((customer) => (
                            <option key={customer.id} value={customer.id}>{getCustomerName(customer)}</option>
                          ))}
                        </select>
                        {selectedBrokerRecord && (
                          <div className="well well-sm" aria-label="Selected broker details" style={{ marginTop: 10, marginBottom: 0 }}>
                            <strong>{getCustomerName(selectedBrokerRecord)} details</strong>
                            {brokerDetails(selectedBrokerRecord).length > 0 ? (
                              <dl className="row" style={{ margin: "8px 0 0" }}>
                                {brokerDetails(selectedBrokerRecord).map(([label, value]) => (
                                  <React.Fragment key={label}>
                                    <dt className="col-sm-4">{label}</dt>
                                    <dd className="col-sm-8">{String(value)}</dd>
                                  </React.Fragment>
                                ))}
                              </dl>
                            ) : <p style={{ margin: "8px 0 0" }}>No additional broker contact details are available.</p>}
                          </div>
                        )}
                        {ocrBrokerInfo && (
                          <div className="alert alert-info" aria-label="Broker information read by OCR" style={{ marginTop: 10, marginBottom: 0 }}>
                            <strong>Broker information read from OCR</strong>
                            <dl className="row" style={{ margin: "8px 0 0" }}>
                              {Object.entries(ocrBrokerInfo).map(([key, value]) => (
                                <React.Fragment key={key}>
                                  <dt className="col-sm-4">{key.charAt(0).toUpperCase() + key.slice(1)}</dt>
                                  <dd className="col-sm-8">{value}</dd>
                                </React.Fragment>
                              ))}
                            </dl>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-3 col-xs-12 pull pull-left">
                      <div className="form-group">
                        <label htmlFor="loadtype">Load Type</label>
                        <select
                          className="form-control"
                          id="loadtype"
                          name="loadtype"
                          value={formData.loadtype}
                          onChange={handleInputChange}
                        >
                          <option> Select Load type</option>
                          <option value="FTL">FTL</option>
                          <option value="LTL">LTL</option>
                          <option value="single">Single </option>
                          <option value="team">Team (Option)</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3 col-xs-12 pull pull-left">
                      <div className="form-group">
                        <label htmlFor="frieghton">Frieght on</label>
                        <select
                          className="form-control"
                          id="frieghton"
                          name="frieghton"
                          value={formData.frieghton}
                          onChange={handleInputChange}
                        >
                          <option value="Order">Order</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3 col-xs-12 pull pull-left">
                      <div className="form-group">
                        <label htmlFor="salesman">Salesman</label>
                        <select
                          className="form-control"
                          id="salesman"
                          name="salesman"
                          value={formData.salesman}
                          onChange={handleInputChange}
                        >
                          <option value="">Select salesperson</option>
                          {data.customers?.map((item) => (
                            <option key={item.id} value={item.id}>{item.name}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3 col-xs-12 pull pull-left">
                      <div className="form-group">
                          <label htmlFor="loadno">Load number</label>
                        <input
                          type="text"
                          className="form-control"
                            id="loadno"
                            name="loadno"
                          placeholder="Enter Load #"
                          autoComplete="off"
                            value={formData.loadno || ""}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-3 col-xs-12 pull pull-left">
                      <div className="form-group">
                        <label htmlFor="scaleticketno">Scale . #</label>
                        <input
                          type="text"
                          className="form-control"
                          id="scaleticketno"
                          name="scaleticketno"
                          placeholder="Enter Scale Ticket #"
                          autoComplete="off"
                          value={
                            formData.scaleticketno
                              ? formData.scaleticketno
                              : data && data.triprno
                          }
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    {/*
          
           <div class="col-md-12 col-xs-12 pull pull-left">
          
          <div class="form-group">
            <label htmlFor="carrier_desc">Description</label>
            <textarea type="text" class="form-control" id="carrier_desc" name="carrier_desc"  autocomplete="off">
                              </textarea>
          </div> 
          </div>
          */}
                  </div>
                </div>
                {/*   
             <div class="col-md-4 col-xs-12 pull pull-left">
              <div class="form-group">
              <label htmlFor="weight">Weight</label>
               <select class="form-control" id="weight" name="weight">
                      
                      <option value="Gallons">Gallons</option>
                      <option value="Grams">Grams</option>
                      <option value="Kilograms">Kilograms</option>
                      <option value="MBF">MBF</option>
                      <option value="Metric Ton">Metric Ton</option>
                      <option value="Ounces">Ounces</option>
                      <option value="Pounds">Pounds</option>
                      <option value="Tons">Tons</option>

              </select>
              </div>
          </div>
          */}
                {/*
              <div class="col-md-3 col-xs-12 pull pull-left">
              <div class="form-group">
              <label htmlFor="measurement">Measurement*</label>
              <select class="form-control" id="measurement" name="measurement">
              <option value="Centimeter">Centimeter</option>
               <option value="Feet">Feet</option>
                <option value="Inches">Inches</option>
                 <option value="Meter">Meter</option>
               
              </select>
              </div>
          </div>
              
             <div class="col-md-3 col-xs-12 pull pull-left">
              
                  <div class="form-group">
                  <label htmlFor="l">L*</label>
                  <input type="text" class="form-control" id="l" name="l"  autocomplete="off">
                  </div>
              
              </div>
                 <div class="col-md-3 col-xs-12 pull pull-left">
              
                  <div class="form-group">
                  <label htmlFor="b">B*</label>
                  <input type="text" class="form-control" id="b" name="b"  autocomplete="off">
                  </div>
              
              </div>
                 <div class="col-md-3 col-xs-12 pull pull-left">
              
                  <div class="form-group">
                  <label htmlFor="h">H*</label>
                  <input type="text" class="form-control" id="h" name="h"  autocomplete="off">
                  </div>
              
              </div>
          
             
              
        
        <!--
          
           <div class="col-md-12 col-xs-12 pull pull-left">
          
          <div class="form-group">
            <label htmlFor="shipment_desc">Description</label>
            <textarea type="text" class="form-control" id="shipment_desc" name="shipment_desc" placeholder="Enter Shipment  Notes" autocomplete="off">
                              </textarea>
          </div> 
          </div>
          */}
              </form>
            </div>
            <div className="col-md-6 col-xs-12 pull pull-right">
              {/*
              <div class="col-md-3 col-xs-12 pull pull-left">
               <label for="store">Pack. Type</label>
              <div class="form-group">
              <input type="text" class="form-control"   name="carr_weight"  list="select-list-id1"/>
              </div>
              <datalist id="select-list-id1">
             
                     
                      <option value="Bag">Bag</option>
                      <option value="Bale">Bale</option>
                      <option value="Barrel">Barrel</option>
                      <option value="Basket">Basket</option>
                      <option value="Bin">Bin</option>
                      <option value="Bing Chest">Bing Chest</option>
                      <option value="Box">Box</option>
                      <option value="Bucket">Bucket</option>
                      <option value="Bundle">Bundle</option>
                      <option value="Can">Can</option>
                      <option value="Can Case">Can Case</option>
                      <option value="Carooy">Carooy</option>
                      <option value="Carcass">Carcass</option>
                      <option value="Carton">Carton</option>
                      <option value="Case">Case</option>
                      <option value="Cask">Cask</option>
                      <option value="Centimeter">Centimeter</option>
                      <option value="Chest">Chest</option>
                      <option value="Coil">Coil</option>
                      <option value="Container Bulk Cargo">Container Bulk Cargo</option>
                      <option value="Cord">Cord</option>
                      <option value="Crate">Crate</option>
                      
                      
                      <option value="Cyilnder">Cyilnder</option>
                      <option value="Drum">Drum</option>
                      <option value="Dry Bulk">Dry Bulk</option>
                      <option value="Feet">Feet</option>
                      <option value="Gallon">Gallon</option>
                      
                      <option value="Hamper">Hamper</option>
                      <option value="Heads of Beef">Heads of Beef</option>
                      <option value="Inches">Inches</option>
                      <option value="Keg">Keg</option>
                      <option value="Lift Van">Lift Van</option>
                      <option value="Liquid Bulk">Liquid Bulk</option>
                      <option value="Logos">Logos</option>
                      <option value="Lugs">Lugs</option>
                      <option value="Meter">Meter</option>
                      <option value="Package">Package</option>
                      <option value="Pail">Pail</option>
                      <option value="Parcel">Parcel</option>
                      <option value="Pieces">Pieces</option>
                      <option value="Private Vehicle">Private Vehicle</option>
                      
                      
                      <option value="Quarters of Beef">Quarters of Beef</option>
                      <option value="Reel">Reel</option>
                      <option value="Roll">Roll</option>
                      <option value="Sack">Sack</option>
                      <option value="Sheet">Sheet</option>
                      <option value="Side of Beef">Side of Beef</option>
                      <option value="Skid">Skid</option>
                      <option value="Tank">Tank</option>
                      <option value="Tin">Tin</option>
                      <option value="Tote Bin">Tote Bin</option>
                      <option value="Truck Load">Truck Load</option>
                      <option value="Tube">Tube</option>
                      <option value="Unit">Unit</option>
                      <option value="Vanpack">Vanpack</option>
                      
                      <option value="Vehicle">Vehicle</option>
                      <option value="Wooden Case">Wooden Case</option>

                                            
                          
                      
              </datalist>
              </div>
              
           */}
            </div>
            <div className="col-md-12 col-xs-12 pull pull-left">
              <div className="form-group">
                <h4 id="trip-route-details">
                  <span className="label label-success">
                    PICKUP/DELIVERY DETAIL
                  </span>
                </h4>
              </div>
            </div>
            <div className="col-md-6 col-xs-12 pull pull-left">
              <div className="col-md-12 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="store">
                    Pickup From |{" "}
                    <Link to="/locations/create">Add Location</Link>{" "}
                  </label>
                  <select
                    className="form-control"
                    id="pickup_from"
                    value={formData.pickup_from}
                    onChange={handleInputChange}
                    name="pickup_from"
                  >
                    <option>Select Pickup Location </option>
                    {data.locations?.map((item) => (
                      <option value={item.id}>{item.name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-12 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="pickup_address">Pickup Address</label>
                  <input
                    type="text"
                    className="form-control"
                    id="pickup_address"
                    name="pickup_address"
                    autoComplete="off"
                    value={formData.pickup_address}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="col-md-4 col-xs-12 pull pull-left">
                <label htmlFor="store">Pickup Date</label>
                <div className="input-group date">
                  <input
                    type="date"
                    name="pickupdate"
                    id="pickupdate"
                    className="form-control"
                    value={formData.pickupdate}
                    onChange={handleInputChange}
                  />
                  <div className="input-group-addon">
                    <span className="glyphicon glyphicon-th" />
                  </div>
                </div>
                <input
                  className="form-control"
                  type="time"
                  id="pickuptime"
                  placeholder="Set Time"
                  name="pickuptime"
                  value={formData.pickuptime}
                  onChange={handleInputChange}
                />
              </div>
              <div className="col-md-4 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="pickup_refno">Refrence No.*</label>
                  <input
                    type="text"
                    className="form-control"
                    id="pickup_refno"
                    defaultValue="ISV_TRIP-1230"
                    name="pickup_refno"
                    autoComplete="off"
                    value={
                      formData.pickup_refno
                        ? formData.pickup_refno
                        : data && data.triprno
                    }
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              {/* 
              <div class="col-md-6 col-xs-12 pull pull-left">
               <label for="store">Weight</label>
              <div class="form-group">
              <input type="text" class="form-control" placeholder="Search/Select  Values" list="select-list-id"/>
              </div>
              <datalist id="select-list-id">
             
               <option value="Gallons">Gallons</option>
                      <option value="Grams">Grams</option>
                      <option value="Kilograms">Kilograms</option>
                      <option value="MBF">MBF</option>
                      <option value="Metric Ton">Metric Ton</option>
                      <option value="Ounces">Ounces</option>
                      <option value="Pounds">Pounds</option>
                      <option value="Tons">Tons</option>
              </datalist>
              </div> */}
              <div className="col-md-12 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="pickup_desc">Pickup Description</label>
                  <textarea
                    type="text"
                    className="form-control"
                    id="pickup_desc"
                    name="pickup_desc"
                    placeholder="Enter Pickup Notes"
                    autoComplete="off"
                    value={formData.pickup_desc}
                    onChange={handleInputChange}
                    defaultValue={"  "}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xs-12 pull pull-right">
              <div className="col-md-12 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="delivery">Deliver To</label>
                  <select
                    className="form-control"
                    id="delivery"
                    name="delivery"
                    value={formData.delivery}
                    onChange={handleInputChange}
                  >
                    <option>Select Drop Location</option>
                    {data.locations?.map((item) => (
                      <option value={item.id}>{item.name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-12 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="delivery_address">Delivery Address</label>
                  <input
                    type="text"
                    className="form-control"
                    id="delivery_address"
                    name="delivery_address"
                    autoComplete="off"
                    value={formData.delivery_address}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="col-md-4 col-xs-12 pull pull-left">
                <label htmlFor="store">Delivery Date</label>
                <div className="input-group date">
                  <input
                    type="date"
                    name="deliverydate"
                    id="deliverydate"
                    className="form-control"
                    value={formData.deliverydate}
                    onChange={handleInputChange}
                  />
                  <div className="input-group-addon">
                    <span className="glyphicon glyphicon-th" />
                  </div>
                </div>
                <input
                  className="form-control"
                  type="time"
                  id="deliverytime"
                  placeholder="Set Time"
                  name="deliverytime"
                  value={formData.deliverytime}
                  onChange={handleInputChange}
                />
              </div>
              <div className="col-md-4 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="delivery_refno">Refrence No.*</label>
                  <input
                    type="text"
                    className="form-control"
                    id="delivery_refno"
                    defaultValue="ISV_TRIP-1230"
                    name="delivery_refno"
                    autoComplete="off"
                    value={
                      formData.delivery_refno
                        ? formData.delivery_refno
                        : data && data.triprno
                    }
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              {/* 
              <div class="col-md-6 col-xs-12 pull pull-left">
               <label for="store">Weight</label>
              <div class="form-group">
              <input type="text" class="form-control" placeholder="Search/Select  Values" list="select-list-id"/>
              </div>
              <datalist id="select-list-id">
             
               <option value="Gallons">Gallons</option>
                      <option value="Grams">Grams</option>
                      <option value="Kilograms">Kilograms</option>
                      <option value="MBF">MBF</option>
                      <option value="Metric Ton">Metric Ton</option>
                      <option value="Ounces">Ounces</option>
                      <option value="Pounds">Pounds</option>
                      <option value="Tons">Tons</option>
              </datalist>
              </div> */}
              <div className="col-md-4 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="dappointment">Appointment</label>
                  <select
                    className="form-control"
                    id="dappointment"
                    name="dappointment"
                    value={formData.dappointment}
                    onChange={handleInputChange}
                  >
                    <option value="YES">YES</option>
                    <option value="NO">NO</option>
                  </select>
                </div>
              </div>
              <div className="col-md-12 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="delivery_desc">Delivery Description</label>
                  <textarea
                    type="text"
                    className="form-control"
                    id="delivery_desc"
                    name="delivery_desc"
                    placeholder="Enter Delivery Notes"
                    autoComplete="off"
                    value={formData.delivery_desc}
                    onChange={handleInputChange}
                    defaultValue={"                                    "}
                  />
                </div>
              </div>
              <input
                type="hidden"
                className="form-control"
                id="lat"
                name="lat"
                autoComplete="off"
              />
              <input
                type="hidden"
                className="form-control"
                id="lng"
                name="lng"
                autoComplete="off"
              />
              <input
                type="hidden"
                className="form-control"
                id="source_lat"
                name="source_lat"
                autoComplete="off"
              />
              <input
                type="hidden"
                className="form-control"
                id="source_lng"
                name="source_lng"
                autoComplete="off"
              />
            </div>
          </div>
          {/* Add Pickup/Delivery Stops Button */}
          <div className="col-md-12 col-xs-12 pull pull-left">
            <div className="form-group">
              <button
                type="button"
                className="btn btn-info btn-sm"
                onClick={addStop}
              >
                Add Pickup/Delivery Stops
              </button>
            </div>
          </div>

          {/* Render Stops Dynamically */}
          {stops.map((stop, index) => (
            <div
              key={index}
              draggable
              onDragStart={(e) => handleDragStart(e, index)}
              onDragOver={(e) => handleDragOver(e, index)}
              onDrop={(e) => handleDrop(e, index)}
              onDragEnd={handleDragEnd}
              style={{
                marginTop: "15px",
                padding: "15px",
                border: "1px solid #ddd",
                borderRadius: "5px",
                backgroundColor: "#f9f9f9",
                cursor: "move",
                opacity: draggedIndex === index ? 0.5 : 1,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <span style={{ marginRight: "10px" }}>☰ Drag to reorder</span>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={() => {
                    const updatedStops = [...stops];
                    updatedStops.splice(index, 1);
                    setStops(updatedStops);
                  }}
                  style={{ marginLeft: "auto" }}
                >
                  Remove
                </button>
              </div>

              <div className="form-group">
                <label>Stop Type</label>
                <select
                  className="form-control"
                  value={stop.stoptype}
                  onChange={(e) =>
                    handleStopChange(index, "stoptype", e.target.value)
                  }
                >
                  <option value="Delivery">Delivery</option>
                  <option value="Pickup">Pickup</option>
                </select>
              </div>
              <div className="form-group">
                <label>Stop name</label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Company or location name"
                  value={stop.name || ""}
                  onChange={(e) => handleStopChange(index, "name", e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Stop address / location</label>
                <input
                  className="form-control"
                  type="text"
                  list={`trip-stop-locations-${index}`}
                  placeholder="Enter or select a saved location"
                  value={stop.location || ""}
                  onChange={(e) => handleStopChange(index, "location", e.target.value)}
                />
                <datalist id={`trip-stop-locations-${index}`}>
                  {data.locations?.map((item) => (
                    <option key={item.id} value={item.address1 || item.name}>{item.name}</option>
                  ))}
                </datalist>
              </div>
              <div className="row">
                <div className="col-sm-6 form-group">
                  <label>Stop date</label>
                  <input className="form-control" type="date" value={stop.date || ""} onChange={(e) => handleStopChange(index, "date", e.target.value)} />
                </div>
                <div className="col-sm-6 form-group">
                  <label>Stop time</label>
                  <input className="form-control" type="time" value={stop.time || ""} onChange={(e) => handleStopChange(index, "time", e.target.value)} />
                </div>
              </div>
            </div>
          ))}
          <div className="col-md-12 col-xs-12 pull pull-left">
            <div
              id="manageTablestops_wrapper"
              className="dataTables_wrapper form-inline dt-bootstrap no-footer"
            >
              <div className="row">
                <div className="col-sm-6">
                  <div
                    className="dataTables_length"
                    id="manageTablestops_length"
                  >
                    <label>
                      Show{" "}
                      <select
                        name="manageTablestops_length"
                        aria-controls="manageTablestops"
                        className="form-control input-sm"
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>{" "}
                      entries
                    </label>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div
                    id="manageTablestops_filter"
                    className="dataTables_filter"
                  >
                    <label>
                      Search:
                      <input
                        type="search"
                        className="form-control input-sm"
                        placeholder=""
                        aria-controls="manageTablestops"
                      />
                    </label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <table
                    id="manageTablestops"
                    className="table table-bordered table-striped dataTable no-footer"
                    role="grid"
                    aria-describedby="manageTablestops_info"
                    style={{ width: 1260 }}
                  >
                    <thead>
                      <tr role="row">
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="manageTablestops"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Type: activate to sort column ascending"
                          style={{ width: "494.2px" }}
                        >
                          Type
                        </th>
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="manageTablestops"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Location: activate to sort column ascending"
                          style={{ width: 669 }}
                        >
                          Location
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="odd">
                        <td
                          valign="top"
                          colSpan={2}
                          className="dataTables_empty"
                        >
                          No data available in table
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-5">
                  <div
                    className="dataTables_info"
                    id="manageTablestops_info"
                    role="status"
                    aria-live="polite"
                  >
                    Showing 0 to 0 of 0 entries
                  </div>
                </div>
                <div className="col-sm-7">
                  <div
                    className="dataTables_paginate paging_simple_numbers"
                    id="manageTablestops_paginate"
                  >
                    <ul className="pagination">
                      <li
                        className="paginate_button previous disabled"
                        id="manageTablestops_previous"
                      >
                        <Link
                          to="#"
                          aria-controls="manageTablestops"
                          data-dt-idx={0}
                          tabIndex={0}
                        >
                          Previous
                        </Link>
                      </li>
                      <li
                        className="paginate_button next disabled"
                        id="manageTablestops_next"
                      >
                        <Link
                          to="#"
                          aria-controls="manageTablestops"
                          data-dt-idx={1}
                          tabIndex={0}
                        >
                          Next
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 col-xs-12 pull pull-left">
            <div className="form-group">
              <h4 id="trip-shipment-details">
                <span className="label label-success">SHIPMENT DETAIL</span>
              </h4>
            </div>
          </div>

          {/* Add this button where you want the multiple shipments functionality */}
          <div className="col-md-12 col-xs-12 pull pull-left">
            <div className="form-group">
              <button
                type="button"
                className="btn btn-info"
                onClick={() => setShowShipmentsPopup(true)}
              >
                Manage Shipments ({shipments.length})
              </button>
            </div>
          </div>

          {/* Shipments Popup Modal */}
          {showShipmentsPopup && (
            <div
              className="modal show"
              style={{ display: "block" }}
              tabIndex={-1}
              role="dialog"
            >
              <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Manage Shipments</h5>
                    <button
                      type="button"
                      className="close"
                      onClick={() => setShowShipmentsPopup(false)}
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    {/* Shipment Tabs */}
                    <ul className="nav nav-tabs">
                      {shipments.map((_, index) => (
                        <li key={index} className="nav-item">
                          <button
                            className={`nav-link ${activeShipmentIndex === index ? "active" : ""
                              }`}
                            onClick={() => setActiveShipmentIndex(index)}
                          >
                            Shipment {index + 1}
                            {shipments.length > 1 && (
                              <span
                                className="badge badge-danger ml-2"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  removeShipment(index);
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                ×
                              </span>
                            )}
                          </button>
                        </li>
                      ))}
                      <li className="nav-item">
                        <button
                          className="nav-link btn-success text-white"
                          onClick={addNewShipment}
                        >
                          + Add
                        </button>
                      </li>
                    </ul>

                    {/* Shipment Content */}
                    <div className="tab-content mt-3">
                      {shipments.map((shipment, index) => (
                        <div
                          key={index}
                          className={`tab-pane ${activeShipmentIndex === index ? "active" : ""
                            }`}
                        >
                          {/* Shipment Form - Similar to your existing shipment section */}
                          <div className="table-responsive">
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th>Commodities</th>
                                  <th>Weight</th>
                                  <th>Unit</th>
                                  <th>Packages</th>
                                  <th>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {shipment.commodity.map(
                                  (commodity, rowIndex) => (
                                    <tr key={rowIndex}>
                                      <td>
                                        <input
                                          type="text"
                                          placeholder="Enter Commodity"
                                          className="form-control"
                                          value={commodity}
                                          onChange={(e) =>
                                            handleShipmentArrayChange(
                                              index,
                                              "commodity",
                                              rowIndex,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          placeholder="Enter Weight"
                                          className="form-control"
                                          value={
                                            shipment.weight[rowIndex] || ""
                                          }
                                          onChange={(e) =>
                                            handleShipmentArrayChange(
                                              index,
                                              "weight",
                                              rowIndex,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <select
                                          className="form-control"
                                          value={shipment.unit[rowIndex] || ""}
                                          onChange={(e) =>
                                            handleShipmentArrayChange(
                                              index,
                                              "unit",
                                              rowIndex,
                                              e.target.value
                                            )
                                          }
                                        >
                                          <option value="">Select Unit</option>
                                          <option value="Gallons">
                                            Gallons
                                          </option>
                                          <option value="KG">KG</option>
                                          <option value="TON">TON</option>
                                          <option value="Metric Ton">
                                            Metric Ton
                                          </option>
                                          <option value="Ounces">Ounces</option>
                                          <option value="MBF">MBF</option>
                                          <option value="Pounds">Pounds</option>
                                        </select>
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          placeholder="Enter No. of Packages"
                                          className="form-control"
                                          value={
                                            shipment.package[rowIndex] || ""
                                          }
                                          onChange={(e) =>
                                            handleShipmentArrayChange(
                                              index,
                                              "package",
                                              rowIndex,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        {rowIndex > 0 && (
                                          <button
                                            type="button"
                                            className="btn btn-danger btn-sm"
                                            onClick={() =>
                                              handleRemoveRowFromShipment(
                                                index,
                                                rowIndex
                                              )
                                            }
                                          >
                                            X
                                          </button>
                                        )}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                            <button
                              type="button"
                              className="btn btn-success btn-sm"
                              onClick={() => handleAddRowToShipment(index)}
                            >
                              + Add Row
                            </button>
                          </div>

                          {/* Other shipment fields */}
                          {/* <div className="row mt-3">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Trailer Type</label>
                      <select
                        className="form-control"
                        value={shipment.trailortype}
                        onChange={(e) => handleShipmentChange(index, 'trailortype', e.target.value)}
                      >
                        <option value="">Choose Trailer Type</option>
                        {data.trailors?.map(item => (
                          <option key={item.id} value={item.trailortype}>
                            {item.trailortype}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>View Manifest</label>
                      <select
                        className="form-control"
                        value={shipment.manifest}
                        onChange={(e) => handleShipmentChange(index, 'manifest', e.target.value)}
                      >
                        <option value="YES">YES</option>
                        <option value="NO">NO</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Hazmat</label>
                      <select
                        className="form-control"
                        value={shipment.hazmat}
                        onChange={(e) => handleShipmentChange(index, 'hazmat', e.target.value)}
                      >
                        <option value="YES">YES</option>
                        <option value="NO">NO</option>
                      </select>
                    </div>
                  </div>
                </div> */}

                          {/* Add more shipment fields as needed */}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="modal-footer">
                {saveError && <Alert tone="danger" title="Trip save failed">{saveError} If a request timed out, check the list for an existing record before retrying.</Alert>}
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setShowShipmentsPopup(false)}
                    >
                      Close
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => setShowShipmentsPopup(false)}
                    >
                      Save Shipments
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="col-md-12 col-xs-12 pull pull-left">
            <div className="table-responsive">
              <table className="table table-bordered" id="dynamic_weight">
                <tbody>
                  <tr>
                    <td>
                      <div className="col-md-12 col-xs-12 pull pull-left">
                        <div className="form-group">
                          <label htmlFor="commodity[]">Commodities(s)</label>
                          <input
                            type="text"
                            className="form-control"
                            id="commodity[]"
                            name="commodity[]"
                            placeholder="Enter Commodity"
                            autoComplete="off"
                            value={formData.commodity}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="col-md-12 col-xs-12 pull pull-left">
                        <div className="form-group">
                          <label htmlFor="weight[]">Weight</label>
                          <input
                            type="text"
                            className="form-control"
                            id="weight[]"
                            name="weight[]"
                            placeholder="Enter Weight"
                            autoComplete="off"
                            value={formData.weight}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="col-md-12 col-xs-12 pull pull-left">
                        <div className="form-group">
                          <label htmlFor="unit[]">Packages(s)</label>
                          <select
                            className="form-control"
                            id="unit[]"
                            name="unit[]"
                            value={formData.unit}
                            onChange={handleInputChange}
                            unit
                          >
                            <option value="Gallons">Gallons</option>
                            <option value="Gallons">Gallons</option>
                            <option value="Grams">Grams</option>
                            <option value="KGs">KGs</option>
                            <option value="MBF">MBF</option>
                            <option value="Metric Ton">Metric Ton</option>
                            <option value="Ounces">Ounces</option>
                            <option value="Pounds">Pounds</option>
                            <option value="Tons">Tons</option>
                          </select>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="col-md-12 col-xs-12 pull pull-left">
                        <div className="form-group">
                          <label htmlFor="package[]">Packages(s)</label>
                          <input
                            type="text"
                            className="form-control"
                            id="package[]"
                            name="package[]"
                            autoComplete="off"
                            value={formData.package}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="col-md-12 col-xs-12 pull pull-left">
                        <div className="form-group">
                          <label htmlFor="username">Add Rows</label>
                          <button
                            type="button"
                            name="add1"
                            id="add1"
                            className="btn btn-success"
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="col-md-3 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="trailortype">Selecct Trailor Type</label>
                  <select
                    className="form-control"
                    id="trailortype"
                    name="trailortype"
                    value={formData.trailortype}
                    onChange={handleInputChange}
                  >
                    <option value="" disabled="" selected="">
                      Choose Trailor Type
                    </option>
                    {data.trailors?.map((item) => (
                      <option value={item.trailortype}>
                        {item.trailortype}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="manifest">View Manifest</label>
                  <select
                    className="form-control"
                    id="manifest"
                    name="manifest"
                    value={formData.manifest}
                    onChange={handleInputChange}
                  >
                    <option value="YES">YES</option>
                    <option value="NO">NO</option>
                  </select>
                </div>
              </div>
              <div className="col-md-3 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="hazmat">Hazmat</label>
                  <select
                    className="form-control"
                    id="hazmat"
                    name="hazmat"
                    value={formData.hazmat}
                    onChange={handleInputChange}
                  >
                    <option value="YES">YES</option>
                    <option value="NO">NO</option>
                  </select>
                </div>
              </div>
              <div className="col-md-3 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="addlcharge">Addl. Charges</label>
                  <input
                    type="text"
                    className="form-control"
                    id="addlcharge"
                    name="addlcharge"
                    autoComplete="off"
                    value={formData.addlcharge}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              {/*
               <div class="col-md-2 col-xs-12 pull pull-left">
              <div class="form-group">
              <label htmlFor="refer">Refer</label>
              <select class="form-control" id="refer" name="refer">
             <option value="C">C</option>
                <option value="F">F</option>
               
              </select>
              </div>
          </div>
          */}
              <div className="col-md-3 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="appt">Delivery by APPT*</label>
                  <input
                    type="text"
                    className="form-control"
                    id="appt"
                    name="appt"
                    autoComplete="off"
                    value={formData.appt}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="col-md-3 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="pip">PIP</label>
                  <select
                    className="form-control"
                    id="pip"
                    name="pip"
                    value={formData.pip}
                    onChange={handleInputChange}
                  >
                    <option value="YES">YES</option>
                    <option value="NO">NO</option>
                  </select>
                </div>
              </div>
              <div className="col-md-3 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="ctpat">CTPAT</label>
                  <select
                    className="form-control"
                    id="ctpat"
                    name="ctpat"
                    value={formData.ctpat}
                    onChange={handleInputChange}
                  >
                    <option value="YES">YES</option>
                    <option value="NO">NO</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-xs-12 pull pull-left">
              <div className="form-group">
                <h4 id="trip-revenue-details">
                  <span className="label label-success">REVENUE DETAILS</span>
                </h4>
              </div>
            </div>
            <div className="col-md-6 col-xs-12 pull pull-left">
              <div className="table-responsive">
                <label htmlFor="store">Revenue Item | Revenue Method</label>
                <div className="form-group">
                  <label htmlFor="currency">Revenue Currency</label>
                  <select className="form-control" id="currency" name="currency" value={formData.currency} onChange={handleInputChange}>
                    <option value="CAD">CAD — Canadian Dollar</option>
                    <option value="USD">USD — US Dollar</option>
                  </select>
                </div>
                <table className="table table-bordered" id="dynamic_field">
                  <tbody>
                    <tr>
                      {/*
              	<td><select name="revitem[]" class="form-control name_list" required >
						     <option value="na" disabled selected>Select Revenue Item</option>
						  <option value="Frieght Charge">Frieght Charge</option>
						  <option value="Fuel Surcharge">Fuel Surcharge</option>
						  </select> </td>	
					
              	<td><select name="ratemethod[]"  class="form-control name_list" required >
              	     <option value="na" disabled selected>Select Rate Type</option>
              	     <option value="Flat">Flat</option>   <option value="RateMile">RateMile</option>    <option value="RateHour">RateHour</option>  <option value="RateItem">RateItem</option>   <option value="Rate/Packages">Rate/Packages</option>   <option value="Rate/Weight">Rate/Weight</option>  <option value="MBF">MBF</option>
						  </select> </td> */}
                      <td>
                        <input
                          type="number"
                          name="rate"
                          placeholder={`Enter Rate (${formData.currency})`}
                          className="form-control name_list"
                          required=""
                          value={formData.rate}
                          onChange={handleInputChange}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          name="ratevalue"
                          onkeyup="sum();"
                          placeholder="Enter Qty"
                          className="form-control name_list"
                          required=""
                          value={formData.ratevalue}
                          onChange={handleInputChange}
                        />{" "}
                      </td>
                      <td>
                        <button
                          type="button"
                          name="add"
                          id="add"
                          className="btn btn-success"
                        >
                          Add More
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col-md-12 col-xs-12 pull pull-left">
                <table className="table">
                  <tbody>
                    <tr>
                      <th scope="row" />
                      <td />
                      <td />
                      <td>Gross Amount ({formData.currency})</td>
                      <td className="text-right">
                        {" "}
                        <input
                          type="number"
                          className="form-control"
                          id="gross_amount"
                          name="gross_amount"
                          defaultValue={0}
                          autoComplete="off"
                          value={formData.gross_amount}
                          onChange={handleInputChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" />
                      <td />
                      <td>HST(%)</td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          id="hst"
                          name="hst"
                          defaultValue={0}
                          autoComplete="off"
                          value={formData.hst}
                          onChange={handleInputChange}
                        />
                      </td>
                      <td>
                        {" "}
                        <input
                          type="number"
                          className="form-control"
                          id="hstamount"
                          name="hstamount"
                          defaultValue={0}
                          autoComplete="off"
                          value={formData.hstamount}
                          onChange={handleInputChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" />
                      <td />
                      <td>CST Amount(%)</td>
                      <td>
                        {" "}
                        <input
                          type="number"
                          className="form-control"
                          id="cst"
                          name="cst"
                          defaultValue={0}
                          autoComplete="off"
                          value={formData.cst}
                          onChange={handleInputChange}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          id="cstamount"
                          name="cstamount"
                          defaultValue={0}
                          autoComplete="off"
                          value={formData.cstamount}
                          onChange={handleInputChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" />
                      <td />
                      <td />
                      <td>Net Amount ({formData.currency})</td>
                      <td>
                        {" "}
                        <input
                          type="number"
                          className="form-control"
                          id="net_amount"
                          name="net_amount"
                          defaultValue={0}
                          autoComplete="off"
                          value={formData.net_amount}
                          onChange={handleInputChange}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/* /.box-body */}
          {/* /.box-body */}
        </div>
        {/* /.box */}
        <div className="text-center">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => setpopup(true)}
          >
            Review &amp; Save Trip
          </button>
          <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">
            Back
          </button>
        </div>
      </section>

      {popup && (
        <div
          className="modal show"
          style={{ display: "block" }}
          tabIndex={-1}
          role="dialog"
          aria-labelledby="trip-save-title"
        >
          <div
            className="modal-dialog custom-modal"
            role="document"
            style={{
              width: "100%", // Adjust width
              height: "700px", // Adjust height
              maxWidth: "100%", // Ensure responsiveness
            }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="trip-save-title">Review route and save trip</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setpopup(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <Distancepopup
                  closePopup={() => setpopup(false)}
                  places1={formData.pickup_address}
                  places2={formData.delivery_address}
                  places3={stops}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleonSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Saving..." : "Save Trip"}
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={handleSaveAndAssign}
                  disabled={isSubmitting}
                >
                  Save &amp; Assign Dispatch
                </button>

                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={() => setpopup(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {popup1 && (
        // eslint-disable-next-line react/jsx-no-undef
        <Linkddstop setpopup1={setpopup1} popup1={popup1} />
      )}
    </div>
  );
};

export default Createtrips;
